import {
  REQUEST_LINK_TOKEN,
  REQUEST_RENTER_STATUS,
  REQUEST_UPDATE_MODE_LINK_TOKEN,
} from '@renter-hub/constants/actionTypes';
import ConfigModel from '@renter-hub/models/Config';

const initState = ConfigModel();

const configReducer = (state = initState, action) => {
  switch (action.type) {
    case REQUEST_RENTER_STATUS.SUCCESS:
      return {
        ...state,
        ...action.payload.config,
      };
    case REQUEST_LINK_TOKEN.SUCCESS:
      return {
        ...state,
        plaidLinkToken: action.payload.data.plaidLinkToken,
        plaidLinkTokenExpiration: action.payload.data.plaidLinkTokenExpiration,
      };
    case REQUEST_UPDATE_MODE_LINK_TOKEN.SUCCESS:
      return {
        ...state,
        plaidLinkToken: action.payload.data.updateModeLinkToken,
        plaidLinkTokenExpiration: action.payload.data.updateModeLinkTokenExpiration,
      };
    default:
      return state;
  }
};

export default configReducer;
